// src/utils/drafts.js
//
// Borradores de formularios en sessionStorage. Cada clave incluye el uid del
// usuario, así que un borrador solo lo lee la cuenta que lo escribió; todos se
// borran al cerrar sesión (clearAllDrafts). Nunca lanzan: sin storage, no hay borrador.
const PREFIX = 'csr:draft:';

export const draftKey = (name, uid) => (uid ? `${PREFIX}${name}:${uid}` : null);

export const readDraft = key => {
  if (!key) return null;
  try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
};

export const writeDraft = (key, value) => {
  if (!key) return;
  try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* sin storage */ }
};

export const removeDraft = key => {
  if (!key) return;
  try { sessionStorage.removeItem(key); } catch { /* sin storage */ }
};

export const clearAllDrafts = () => {
  try {
    Object.keys(sessionStorage).filter(k => k.startsWith(PREFIX)).forEach(k => sessionStorage.removeItem(k));
  } catch { /* sin storage */ }
};
